import {Component, ChangeDetectionStrategy} from '@angular/core';

import {Modal} from '@softline/ui-core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { A11yModule } from '@angular/cdk/a11y';

export type CANCELED = {};

import { MultilineInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-kommentar-dialog',
    imports: [ReactiveFormsModule, A11yModule,
    MultilineInputComponent,
    TranslatePipe],
    templateUrl: './kommentar-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./kommentar-dialog.component.css']
})
export class KommentarDialogComponent implements Modal<string | null> {

  close!:  (result: string | null) => void;

  readonly form = new FormGroup({
    kommentar: new FormControl<string | null>(null)
  });

  set kommentar(value: string | null) {
    if (!value) {
      return;
    }

    this.form.patchValue({ kommentar: value })
  };

  constructor() {}

  registerCloseHandler(handler: (result: string | null) => void) {
    this.close = handler;
  }

  saveKommentar() {    
    this.close(this.form.value?.kommentar ?? null);
  }
}
